<template>
    <div id="ReportClinicalNotes">
        <MdTitle v-bind:Text="$t('dailyServiceCharge.RepTitle')" />

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="DateFrom"
                    @input="DateFrom = $event"
                    :Id="'DailyServiceChargeDateFrom'"
                    :Type="'date'"
                    :isRequired="false"
                    :OnPressEnter="SearchDailyServiceCharge"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="DateTo"
                    @input="DateTo = $event"
                    :Id="'DailyServiceChargeDateTo'"
                    :Type="'date'"
                    :isRequired="false"
                    :OnPressEnter="SearchDailyServiceCharge"
                    :isConfirm="false"
                    :ReadOnly="false"
                    v-bind:isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('dailyServiceCharge.DateType')"
                    v-bind:Options="dateTypeOptions"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="DateTypeModel"
                    v-bind:Multiple="false"
                    :Input="ChangeDateType"
                    v-bind:AllowEmpty="false"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Patient', 2)"
                    v-bind:Options="PatientsList"
                    v-bind:Model="PatientCodeModel"
                    v-bind:FieldDescription="'patientName'"
                    v-bind:FieldCode="'patientcode'"
                    v-bind:Multiple="true"
                    :Input="ChangeDropDownPatients"
                    :CustomLabel="customLabelPatients"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Program', 2)"
                    v-bind:Options="ProgramList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="true"
                    v-bind:Model="ProgramModel"
                    :Input="ChangeDropDownPrograms"
                    :CustomLabel="customLabelNameCode"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('dailyServiceCharge.BillTher')"
                    v-bind:Options="therapistList"
                    v-bind:Model="billingTherapists"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="true"
                    :Input="ChangeBillingTherapists"
                    :CustomLabel="customLabelNameCode"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('dailyServiceCharge.SignedTher')"
                    v-bind:Options="therapistList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="true"
                    v-bind:Model="signedTherapists"
                    :Input="ChangeSignedTherapists"
                    :CustomLabel="customLabelNameCode"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Therapies')"
                    v-bind:Options="TherapiesList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="TherapiesModel"
                    v-bind:Multiple="true"
                    :Input="ChangeDropDownTherapies"
                    :CustomLabel="customLabelNameCode"
                />
            </b-col>
        </b-row>

        <!--
      <b-row>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="'Facilities'"
            v-bind:Options="facilitiesOptions"
            v-bind:FieldDescription="'company'"
            v-bind:FieldCode="'code'"
            v-bind:Model="FacilitiesModel"  
            v-bind:Multiple="true" 
            :Input="ChangeFacilities"/>
        </b-col>
      </b-row>
      -->
        <MdTitle
            v-bind:Text="$tc('Insurance.Insurance')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('dailyServiceCharge.UseCategory')"
                    v-bind:Name="'UseCategory'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="useCategory"
                    v-on:change="ChangeUseCategory"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    ref="primaryInsurances"
                    v-bind:Label="$t('HouseFile.PrimaryInsurances')"
                    v-bind:Options="primaryInsuranceOptions"
                    v-bind:FieldDescription="'company'"
                    v-bind:FieldCode="'insurancecode'"
                    v-bind:Model="primaryInsurances"
                    v-bind:Multiple="true"
                    :Input="ChangePrimaryInsurances"
                    :CustomLabel="customLabelCompanyCode"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('dailyServiceCharge.NoSecondaryInsurance')"
                    v-bind:Name="'NoSecondaryInsurance'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="noSecondaryInsurance"
                    v-on:change="ChangeNoSecondaryInsurance"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    ref="secondaryInsurances"
                    v-bind:Label="$t('dailyServiceCharge.SecInsurances')"
                    v-bind:Options="secondaryInsuranceOptions"
                    v-bind:FieldDescription="'company'"
                    v-bind:FieldCode="'insurancecode'"
                    v-bind:Model="secondaryInsurances"
                    v-bind:Multiple="true"
                    :Input="ChangeSecondaryInsurances"
                    v-bind:IsDisabled="isDisableSecondaryInsurances"
                    :CustomLabel="customLabelCompanyCode"
                />
            </b-col>
        </b-row>
        <MdTitle
            v-bind:Text="$t('dailyServiceCharge.DisplayOpt')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('dailyServiceCharge.GroupBy')"
                    v-bind:Options="groupByOptions"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="groupBy"
                    v-bind:Multiple="false"
                    :Input="ChangeGroupBy"
                    v-bind:AllowEmpty="false"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('dailyServiceCharge.Include')"
                    v-bind:Options="showOptions"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="showModel"
                    v-bind:Multiple="false"
                    :Input="ChangeShow"
                    v-bind:AllowEmpty="false"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Show')"
                    v-bind:Options="displayOptions"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="displayModel"
                    v-bind:Multiple="false"
                    :Input="ChangeDisplay"
                    v-bind:AllowEmpty="false"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('dailyServiceCharge.FiltersReport')"
                    v-bind:Name="'IncludeFiltersInReport'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="IncludeFiltersInReport"
                    v-on:change="ChangeIncludeFiltersInReport"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="text-md-right mt-3">
                    <button
                        v-on:click="SearchDailyServiceCharge"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <div class="row">
            <div class="col-md-12">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:refTable="refTable"
                            v-bind:IsViewListAllergies="true"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="reportList"
                v-bind:Name="'btn_ReportList'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="print"
                v-bind:Name="'btn_Print'"
            />

            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$t('Shared.Export')"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item v-on:click="handlePdf('export')">{{
                    $t('Shared.PDF')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handlePdf('email')">{{
                    $t('Shared.PDFByEmail')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('export')">{{
                    $t('Shared.CSV')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('email')">{{
                    $t('Shared.CSVByEmail')
                }}</b-dropdown-item>
            </b-dropdown>
        </div>
        <DxPopup
            :visible="isReportVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('dailyServiceCharge.RepTitle')"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
            <ReportViewer
                ref="dailyServiceCharge"
                :ReportName="'DailyServiceCharge'"
                :ReportTitle="$t('dailyServiceCharge.RepTitle')"
                :IsAnAPIReport="true"
            />
        </DxPopup>

        <CSVExportHelper
            ref="csvExportHelper"
            v-bind:conformSubject="$t('dailyServiceCharge.RepTitle')"
            v-bind:sendEmailAPI="'/Utils/sendEmail'"
            v-bind:exportCsvAPI="'/DailyServiceCharge/exportCSV'"
        >
        </CSVExportHelper>
    </div>
</template>

<script>
import Utils from '@/common/utils';
import PatientService from '@/services/patient.service';
import DailyServiceCharge from '@/services/dailyservicecharge.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import ProgramService from '@/services/programs.services';
import ClinicalService from '@/services/clinical.service';
import EmployeeService from '@/services/employee.service';
import InsuranceService from '@/services/insurance.service';
import { DxPopup } from 'devextreme-vue/popup';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'DailyServiceCharge',
    mixins: [ShowMessage, Utils, DBFunctions],
    components: { DxPopup },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            isReportVisible: false,
            useCategory: false,
            noSecondaryInsurance: false,
            facilitiesOptions: [],
            groupBy: {
                value: 'patients',
                text: this.$tc('Shared.Patient', 2)
            },
            groupByOptions: [
                { value: 'patients', text: this.$tc('Shared.Patient', 2) },
                { value: 'billingtherapist', text: this.$t('dailyServiceCharge.BillTherapist') },
                { value: 'insurances', text: this.$tc('Insurance.Insurance', 2) },
                { value: 'programs', text: this.$tc('Shared.Program', 2) },
                { value: 'therapies', text: this.$t('Shared.Therapies') },
                { value: 'signedtherapist', text: this.$t('dailyServiceCharge.SigTherapist') }
            ],
            showModel: {
                value: 'all',
                text: this.$t('Shared.All')
            },
            displayModel: {
                value: 'detail',
                text: this.$t('Shared.Detail')
            },
            showOptions: [
                { value: 'all', text: this.$t('Shared.All') },
                { value: 'billed', text: this.$t('modalClaimDetail.Billed') },
                { value: 'unbilled', text: this.$t('dailyServiceCharge.Unbilled') }
            ],
            displayOptions: [
                { value: 'detail', text: this.$t('Shared.Detail') },
                { value: 'summary', text: this.$t('Shared.Summary') }
            ],
            DateTypeModel: {
                value: 'service',
                text: this.$t('MdNote.Service')
            },
            dateTypeOptions: [
                { value: 'service', text: this.$t('MdNote.Service') },
                { value: 'post', text: this.$t('dailyServiceCharge.Post') }
            ],
            summaryModel: false,
            therapistList: [],
            billingTherapists: '',
            signedTherapists: '',
            DateFrom: Utils.formatterDate(Date(), 'LLLL'),
            DateTo: Utils.formatterDate(Date(), 'LLLL'),
            PatientCodeModel: '',
            ProgramModel: '',
            TherapiesModel: '',
            FacilitiesModel: '',
            PatientsList: [],
            ProgramList: [],
            TherapiesList: [],
            parameter: {
                PageNumber: null,
                PageSize: null,
                Status: true
            },
            primaryInsuranceOptions: [],
            secondaryInsuranceOptions: [],
            primaryInsurances: null,
            secondaryInsurances: null,
            isDateFromValid: true,
            isDateToValid: true,
            isDisableSecondaryInsurances: false,
            reportParams: [],
            IncludeFiltersInReport: false,
            params: {
                PatientCode: [],
                ProgramCode: [],
                BillingTherapists: [],
                SignedTherapists: [],
                TherapiesCode: [],
                PrimaryInsurances: [],
                SecondaryInsurances: [],
                Facilities: [],
                NoSecondaryInsurance: false,
                DateFrom: Utils.formatterDate(Date(), 'LLLL'),
                DateTo: Utils.formatterDate(Date(), 'LLLL'),
                UseCategory: false,
                GroupBy: 'patients',
                DateType: 'service',
                Show: 'all',
                IsSummary: false,
                IncludeFiltersInReport: false
            },
            ShowMessageIsEmpty: true,
            fields: [
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                {
                    key: 'patientname',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left'
                },
                {
                    key: 'chartNo',
                    sortable: true,
                    label: this.$t('Shared.ChartNo'),
                    class: 'text-left'
                },
                {
                    key: 'serviceDate',
                    sortable: true,
                    label: this.$t('Shared.ServiceDate'),
                    class: 'text-left'
                },
                // { key: 'courseCode', sortable: true, label: this.$t('Shared.CourseCode'), class: 'text-right hidden' },
                {
                    key: 'courseName',
                    sortable: true,
                    label: this.$t('Shared.CourseName'),
                    class: 'text-left'
                },
                // { key: 'progCode', sortable: true, label: this.$t('Shared.ProgramCode'), class: 'text-right hidden' },
                {
                    key: 'progName',
                    sortable: true,
                    label: this.$tc('Shared.Program'),
                    class: 'text-left'
                },
                // { key: 'therapistCode', sortable: true, label: this.$t('Shared.TherapistCode'), class: 'text-right hidden' },
                {
                    key: 'therapistName',
                    sortable: true,
                    label: this.$t('Shared.TherapistName'),
                    class: 'text-left'
                },
                // { key: 'signedTherapistCode', sortable: true, label: this.$t('Shared.SignedTherapistCode'), class: 'text-right hidden' },
                {
                    key: 'signedTherapistName',
                    sortable: true,
                    label: this.$t('MdNote.Cosignedby'),
                    class: 'text-left'
                },
                {
                    key: 'doc',
                    sortable: true,
                    label: this.$t('employee.Document'),
                    class: 'text-left'
                },
                {
                    key: 'unit',
                    sortable: true,
                    label: this.$t('Shared.Unit'),
                    class: 'text-left'
                },
                {
                    key: 'timeFrom',
                    sortable: true,
                    label: this.$t('MdCurrentAppointment.StarTime'),
                    class: 'text-left'
                },
                {
                    key: 'timeTo',
                    sortable: true,
                    label: this.$t('MdCurrentAppointment.EndTime'),
                    class: 'text-left'
                },
                {
                    key: 'billable',
                    sortable: true,
                    label: this.$t('Shared.Billable'),
                    class: 'text-left'
                },
                {
                    key: 'billed',
                    sortable: true,
                    label: this.$t('modalClaimDetail.Billed'),
                    class: 'text-left'
                },
                // { key: 'facilityCode', sortable: true, label: this.$t('Shared.FacilityCode'), class: 'text-left' },
                {
                    key: 'diagCode1',
                    sortable: true,
                    label: this.$t('Shared.Diagnosis'),
                    class: 'text-left'
                },
                // { key: 'ins_Code', sortable: true, label: this.$t('Shared.InsuranceCode'), class: 'text-right hidden' },
                {
                    key: 'insuranceName',
                    sortable: true,
                    label: this.$t('Shared.colInsuranceName'),
                    class: 'text-left'
                },
                // { key: 'ins_No', sortable: true, label: this.$t('Shared.InsuranceNo'), class: 'text-right hidden' },
                {
                    key: 'amt',
                    sortable: true,
                    label: this.$t('Shared.AmountValCode'),
                    class: 'text-left'
                }
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            selected: [],
            Header: {},
            refTable: 'selectableTable',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },
    methods: {
        customLabelNameCode({ name, code }) {
            return `${name} – ${code}`;
        },

        customLabelCompanyCode({ company, insurancecode }) {
            return `${company} – ${insurancecode}`;
        },

        customLabelPatients({ patientName, patientcode }) {
            return `${patientName} – ${patientcode}`;
        },

        print() {
            if (!this.validateForm()) return;
            this.onClickShowReport();
        },

        validate_date_range() {
            return Utils.isDateFromAndDateTo(this.DateFrom, this.DateTo);
        },

        validate_required() {
            this.isDateFromValid = !!this.DateFrom;
            this.isDateToValid = !!this.DateTo;
            return this.isDateFromValid && this.isDateToValid;
        },

        // Método de validación reutilizable
        validateForm() {
            // if (!this.validate_required()) {
            //   this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "error");
            //   return false;
            // }

            const isValid = this.validate_date_range();

            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;

            // Forzar actualización del componente
            this.$forceUpdate();

            if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), 'error');
                return false;
            }
            return true;
        },

        onHiddenReport() {
            this.isReportVisible = false;
            //this.closeWindow()
        },

        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        getAllEmployee() {
            EmployeeService.getEmployeeLookup()
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.therapistList = response.data.map(element => ({
                            code: element.code,
                            name: element.description
                        }));
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        ChangeDropDownPatients(values) {
            this.params.PatientCode = [];
            values.forEach(it => {
                this.params.PatientCode.push(it.patientcode);
            });
        },

        ChangeDropDownPrograms(values) {
            this.params.ProgramCode = [];
            values.forEach(it => {
                this.params.ProgramCode.push(it.code);
            });
        },

        ChangeBillingTherapists(values) {
            this.params.BillingTherapists = [];
            values.forEach(it => {
                this.params.BillingTherapists.push(it.code);
            });
        },

        ChangeSignedTherapists(values) {
            this.params.SignedTherapists = [];
            values.forEach(it => {
                this.params.SignedTherapists.push(it.code);
            });
        },

        ChangeDropDownTherapies(values) {
            this.params.TherapiesCode = [];
            values.forEach(it => {
                this.params.TherapiesCode.push(it.code);
            });
        },

        ChangePrimaryInsurances(values) {
            this.params.PrimaryInsurances = [];
            values.forEach(it => {
                this.params.PrimaryInsurances.push(it.insurancecode);
            });
        },

        ChangeSecondaryInsurances(values) {
            this.params.SecondaryInsurances = [];
            values.forEach(it => {
                this.params.SecondaryInsurances.push(it.insurancecode);
            });
        },

        ChangeNoSecondaryInsurance(value) {
            this.isDisableSecondaryInsurances = value;
            this.params.NoSecondaryInsurance = value;
            this.params.SecondaryInsurances = value ? [] : this.secondaryInsurances;
        },

        async ChangeUseCategory(value) {
            this.params.UseCategory = value;

            this.primaryInsuranceOptions = [];
            this.secondaryInsuranceOptions = [];

            this.params.PrimaryInsurances = [];
            this.params.SecondaryInsurances = [];

            this.$refs.primaryInsurances.clearSelection();
            this.$refs.secondaryInsurances.clearSelection();

            if (value) {
                // Ejecutar en paralelo si son independientes
                await Promise.all([this.getInsurancePriSec('P'), this.getInsurancePriSec('S')]);
            } else {
                this.getInsurances(); // Sin await
            }
        },

        ChangeGroupBy(item) {
            this.params.GroupBy = item.value;
        },

        ChangeDateType(item) {
            this.params.DateType = item.value;
        },

        ChangeShow(item) {
            this.params.Show = item.value;
        },
        ChangeDisplay(item) {
            this.params.IsSummary = item.value == 'detail' ? false : true;
        },
        ChangeSummary(value) {
            this.params.IsSummary = value;
        },

        ChangeIncludeFiltersInReport(value) {
            this.params.IncludeFiltersInReport = value;
        },

        ChangeFacilities(values) {
            this.params.Facilities = [];
            values.forEach(it => {
                this.params.Facilities.push(it.code);
                this.FacilitiesModel.push(it.code);
            });
        },

        getPatients() {
            PatientService.getAll(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.PatientsList = response.data;
                        this.PatientsList.forEach(function(element) {
                            element.patientName = element.firstname + ' ' + element.lastname;
                        });
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getTherapies() {
            ClinicalService.getTherapies()
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.TherapiesList = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getPrograms() {
            ProgramService.getAll(this.parameter)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.ProgramList = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getInsurances() {
            InsuranceService.getAllInsurances(this.parameter)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.primaryInsuranceOptions = response.data;
                        this.secondaryInsuranceOptions = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async getInsurancePriSec(Ins_Type) {
            let param = [];
            param.Ins_Type = Ins_Type;
            await InsuranceService.getInsurancePriSec(param)
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        if (Ins_Type == 'P') this.primaryInsuranceOptions = response.data;
                        if (Ins_Type == 'S') this.secondaryInsuranceOptions = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        getFacilities() {
            PatientService.getFacilities('')
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.facilitiesOptions = response.data;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.RetrieveInformation'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        SearchDailyServiceCharge() {
            if (!this.validateForm()) return;
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getDailyServiceCharge();
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getDailyServiceCharge();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getDailyServiceCharge();
        },

        onRowSelected(items) {
            this.selected = items;
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        reportList() {
            this.checkExistFavorite('/app/reports/billing');
            this.$router.push({ name: 'reportListBilling' }).catch(() => {});
        },

        initializeParameters() {
            this.parameter.BillingTherapists =
                this.params.BillingTherapists && this.params.BillingTherapists !== ''
                    ? this.params.BillingTherapists
                    : null;
            this.parameter.SignedTherapists =
                this.params.SignedTherapists && this.params.SignedTherapists !== ''
                    ? this.params.SignedTherapists
                    : null;
            this.parameter.PatientCode =
                this.params.PatientCode && this.params.PatientCode !== ''
                    ? this.params.PatientCode
                    : null;
            this.parameter.TherapiesCode =
                this.params.TherapiesCode && this.params.TherapiesCode !== ''
                    ? this.params.TherapiesCode
                    : null;
            this.parameter.PrimaryInsurances =
                this.params.PrimaryInsurances && this.params.PrimaryInsurances !== ''
                    ? this.params.PrimaryInsurances
                    : null;
            this.parameter.SecondaryInsurances =
                this.params.SecondaryInsurances && this.params.SecondaryInsurances !== ''
                    ? this.params.SecondaryInsurances
                    : null;
            this.parameter.Facilities =
                this.params.Facilities && this.params.Facilities !== ''
                    ? this.params.Facilities
                    : null;
            this.parameter.ProgramCode =
                this.params.ProgramCode && this.params.ProgramCode !== ''
                    ? this.params.ProgramCode
                    : null;
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.parameter.NoSecondaryInsurance = this.params.NoSecondaryInsurance;
            this.parameter.UseCategory = this.params.UseCategory;
            this.parameter.Show = this.params.Show;

            this.parameter.GroupBy = this.params.GroupBy;
            this.parameter.DateType = this.params.DateType;
            this.parameter.IsSummary = this.params.IsSummary;
            this.parameter.IncludeFiltersInReport = this.params.IncludeFiltersInReport;

            this.parameter.DateFrom = this.DateFrom;
            this.parameter.DateTo = this.DateTo;
        },

        initializePdfParameters() {
            this.reportParams = [];
            this.reportParams.push({
                paramName: 'patientCode',
                paramValue: this.params.PatientCode
            });
            this.reportParams.push({
                paramName: 'programCode',
                paramValue: this.params.ProgramCode
            });
            this.reportParams.push({
                paramName: 'billingTherapists',
                paramValue: this.params.BillingTherapists
            });
            this.reportParams.push({
                paramName: 'signedTherapists',
                paramValue: this.params.SignedTherapists
            });
            this.reportParams.push({
                paramName: 'therapiesCode',
                paramValue: this.params.TherapiesCode
            });
            this.reportParams.push({
                paramName: 'primaryInsurances',
                paramValue: this.params.PrimaryInsurances
            });
            this.reportParams.push({
                paramName: 'secondaryInsurances',
                paramValue: this.params.SecondaryInsurances
            });
            this.reportParams.push({ paramName: 'facilities', paramValue: this.params.Facilities });
            this.reportParams.push({
                paramName: 'noSecondaryInsurance',
                paramValue: this.params.NoSecondaryInsurance
            });
            this.reportParams.push({ paramName: 'dateFrom', paramValue: this.DateFrom });
            this.reportParams.push({ paramName: 'dateTo', paramValue: this.DateTo });
            this.reportParams.push({
                paramName: 'useCategory',
                paramValue: this.params.UseCategory
            });
            this.reportParams.push({ paramName: 'groupBy', paramValue: this.params.GroupBy });
            this.reportParams.push({ paramName: 'dateType', paramValue: this.params.DateType });
            this.reportParams.push({ paramName: 'show', paramValue: this.params.Show });
            this.reportParams.push({ paramName: 'isSummary', paramValue: this.params.IsSummary });
            this.reportParams.push({
                paramName: 'includeFiltersInReport',
                paramValue: this.params.IncludeFiltersInReport
            });
        },

        onClickShowReport() {
            this.initializePdfParameters();
            this.isReportVisible = true;
            this.$refs.dailyServiceCharge.buildDocument(this.reportParams);
        },

        getDailyServiceCharge() {
            this.initializeParameters();

            DailyServiceCharge.getAll(this.parameter, true)
                .then(response => {
                    this.ShowMessageIsEmpty = false;
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.items = response.data;
                        this.items.forEach(function(element) {
                            if (element.serviceDate)
                                element.serviceDate = Utils.formatterDateToString(
                                    element.serviceDate
                                );
                            if (element.timeFrom)
                                element.timeFrom = Utils.formatTime2(element.timeFrom);
                            if (element.timeTo) element.timeTo = Utils.formatTime2(element.timeTo);
                        });
                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }
                    if (this.items.length === 0) {
                        this.ShowMessageIsEmpty = true;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch (action) {
                case 'export':
                    this.$refs.csvExportHelper.exportCSV(this.parameter);
                    break;
                case 'email':
                    this.$refs.csvExportHelper.emailCSV(this.parameter);
                    break;
                default:
                    console.warn('unknow action:', action);
                    break;
            }
        },

        handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch (action) {
                case 'export':
                    this.$refs.csvExportHelper.exportToPdf(
                        'DailyServiceCharge',
                        true,
                        false,
                        this.reportParams
                    );
                    break;
                case 'email':
                    this.$refs.csvExportHelper.emailPdf(
                        'DailyServiceCharge',
                        true,
                        false,
                        this.reportParams
                    );
                    break;
                default:
                    console.warn('unknow action:', action);
                    break;
            }
        }
    },

    created() {
        this.getPatients();
        this.getPrograms();
        this.getTherapies();
        this.getAllEmployee();
        this.getInsurances();
        //this.getFacilities()
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        EventBus.$on(
            'ShowWeel',
            function(isShow) {
                isShow ? this.$emit('load', true) : this.$emit('load', false);
            }.bind(this)
        );
    }
};
</script>
<style>
#fileList {
    padding: 1em;
}
</style>
